import { Link } from "react-router-dom";
import Footer from "@/components/Footer";

// Standalone layout for public, unauthenticated content pages.
export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="border-b border-border bg-card" data-testid="public-header">
        <div className="max-w-[1600px] mx-auto px-6 h-16 flex items-center">
          <Link to="/" className="flex items-center gap-2" data-testid="public-brand">
            <div className="w-8 h-8 bg-primary flex items-center justify-center rounded-sm">
              <span className="font-heading font-black text-primary-foreground text-lg leading-none">G</span>
            </div>
            <span className="font-heading font-bold tracking-tight text-foreground">GrowthAI</span>
          </Link>
        </div>
      </header>
      <main className="flex-1 w-full max-w-3xl mx-auto px-6 py-10 md:py-16" data-testid="public-main">
        {children}
      </main>
      <Footer />
    </div>
  );
}
